import { MUIStyledCommonProps, styled } from '@mui/system';
import clsx from 'clsx';

interface LoadingProps {
  isLoading: boolean;
  isWindow?: boolean;
  className?: string;
}

interface SpinnerStyledProps extends MUIStyledCommonProps {
  ownerState?: Pick<LoadingProps, 'isWindow' | 'isLoading'>;
}

const StyledLodingBox = styled('div')<SpinnerStyledProps>(({ ownerState }) => ({
  ...(ownerState?.isWindow &&
    ownerState.isLoading && {
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(220, 220, 220, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
    }),
}));

function Spinner({ isLoading, isWindow, className }: LoadingProps) {
  const spinnerClsx = clsx({
    'c-loader': isLoading,
    [className]: !!className,
  });
  return (
    <StyledLodingBox ownerState={{ isWindow, isLoading }}>
      <div className={spinnerClsx}></div>
    </StyledLodingBox>
  );
}

export { Spinner };
